import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
export function ControlSurface({
  container,
  children
}) {
  return container ? createPortal(children, container) : children;
}
export function ControlDisclosure({
  active = false,
  title,
  children
}) {
  return active ? <details className="mc-disclosure"><summary>{title}</summary>{children}</details> : children;
}
export function QueueWaitTime({
  createdAt
}) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 60000);
    return () => window.clearInterval(id);
  }, []);
  const start = new Date(createdAt || '').getTime();
  return <span className="mc-wait-time">◷ {Number.isFinite(start) ? `รอ ${Math.max(0, Math.floor((now - start) / 60000))} นาที` : 'รอเริ่มแข่ง'}</span>;
}
export function ControlButton({
  variant = 'secondary',
  busy = false,
  children,
  className = '',
  disabled,
  ...props
}) {
  return <button type="button" {...props} disabled={disabled || busy} aria-busy={busy || undefined} className={`mc-button mc-button-${variant} ${className}`}>
    {busy && <span className="mc-spinner" aria-hidden="true" />}{children}
  </button>;
}
export function StatusBadge({
  tone = 'neutral',
  children
}) {
  return <span className={`mc-status mc-status-${tone}`}><i aria-hidden="true" />{children}</span>;
}
export function EmptyState({
  title,
  description,
  children
}) {
  return <div className="mc-empty"><span aria-hidden="true">◇</span><strong>{title}</strong><p>{description}</p>{children}</div>;
}
export function BoardSkeleton() {
  return <div className="mc-skeleton" role="status" aria-label="กำลังโหลดข้อมูลการแข่งขัน"><span /><span /><span /><span /><small>กำลังโหลดข้อมูลสนามและผู้เล่น…</small></div>;
}
export function OverflowMenu({
  label = 'คำสั่งเพิ่มเติม',
  children
}) {
  const menuRef = useRef(null);
  return <details className="mc-overflow" ref={menuRef} onKeyDown={event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      menuRef.current.open = false;
      menuRef.current.querySelector('summary')?.focus();
    }
  }}>
    <summary aria-label={label} title={label}>•••</summary>
    <div className="mc-overflow-content" onClick={event => {
      if (event.target.closest('button:not(:disabled)')) menuRef.current.open = false;
    }}>{children}</div>
  </details>;
}
export function BoardTabs({
  items,
  value,
  onChange
}) {
  return <nav className="mc-board-tabs" role="tablist" aria-label="สถานะการแข่งขัน">{items.map((item, index) => <button key={item.value} id={`mc-tab-${item.value}`} type="button" role="tab" aria-selected={value === item.value} aria-controls={`mc-panel-${item.value}`} tabIndex={value === item.value ? 0 : -1} onClick={() => onChange(item.value)} onKeyDown={event => {
      const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      if (!direction && event.key !== 'Home' && event.key !== 'End') return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + direction + items.length) % items.length;
      onChange(items[next].value);
      event.currentTarget.parentElement.children[next].focus();
    }}><span>{item.label}</span><b>{item.count}</b></button>)}</nav>;
}
export function SelectedPlayerCard({
  player,
  index,
  onRemove,
  protectedPair,
  avatar
}) {
  return <article className="mc-selected-player">
    {avatar}<span><strong>{player.name || '-'}</strong><small>T{index < 2 ? 1 : 2} · {player.level_rank || '-'} · {Number(player.point || 0).toLocaleString('th-TH')}</small></span>
    {protectedPair ? <span title="คู่บังคับ: กรุณาแก้จากตัวเลือกคู่">🔒</span> : onRemove && <button type="button" aria-label={`นำ ${player.name} ออกจากการเลือก`} onClick={onRemove}>×</button>}
  </article>;
}
